export const ACCEPT_PLATFORM_AGREEMENT = "CACHE_ACCEPT_PLATFORM_AGREEMENT";

export interface AcceptPlatformAgreementAction {
  type: typeof ACCEPT_PLATFORM_AGREEMENT;
}
